export enum GridType {
  Search = 'dossierSearchGrid',
  Display = 'display'
}
